import {Component, Input, NgModule, OnInit} from '@angular/core';
import {CmsService} from '../../../services/cms.service';
import {CasestudyService} from '../../../services/casestudy.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Store} from '../../../store';
import {CommonModule, Location} from '@angular/common';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {SharedModule} from '../../../shared/shared.module';
import {DirectivesModule} from '../../../directives/directives.module';

@Component({
    selector: 'app-case-study-plugin',
    templateUrl: './case-study-plugin.component.html',
    styleUrls: ['./case-study-plugin.component.scss'],
    animations: [
        trigger('fadeIn', [
            state('void', style({opacity: '0'})),
            transition('void <=> *', [
                animate('600ms ease-in')
            ]),
        ]),
    ]
})
export class CaseStudyPluginComponent implements OnInit {
    @Input() backgroundColour = 'bg-grey';
    deviceType$ = this.store.select<string>('deviceType');

    params = {
        companyId: '',
        excludeId: '',
        public: true,
        limit: 12,
        limits: [5, 10, 15, 150],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: 'case_study.createdAt DESC',
        sorts: [],
    };

    items = [];
    filters = [
        {
            name: 'type',
            placeholder: 'Product Type',
            options: []
        },
        {
            name: 'range',
            placeholder: 'Product Range',
            options: []
        },
        {
            name: 'age',
            placeholder: 'Age',
            options: []
        },
        {
            name: 'colour',
            placeholder: 'Colour',
            options: []
        },
        {
            name: 'sort',
            placeholder: 'Sort',
            options: []
        }
    ];
    totalRecords: number;
    nextPage: number;
    moreEntries = true;

    constructor(
        private cmsService: CmsService,
        private casestudyService: CasestudyService,
        private store: Store,
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe(params => {
            const page = params.page;
            if (page) {
                this.params.page = page;
                this.nextPage = +page + 1;

                if (page === '0') {
                    this.router.navigate(['/case-studies']);
                }
            } else {
                this.nextPage = 1;
            }
        });
        this.search();
    }

    search() {
        this.casestudyService.search(this.params).subscribe(data => {
            this.totalRecords = data.data.totalRecords;
            this.items = data.data.data;
            if (this.totalRecords / this.params.limit <= this.nextPage) {
                this.moreEntries = false;
            }
        });
    }

    showMore(event) {
        event.preventDefault();
        if (this.moreEntries) {
            this.params.page++;
            this.casestudyService.search(this.params).subscribe(data => {
                const caseStudies = data.data.data;
                if (caseStudies.length > 0) {
                    caseStudies.forEach(caseStudy => {
                        this.items.push(caseStudy);
                    });
                }
                this.location.go('/case-studies/page/' + this.nextPage);
                this.nextPage++;
                if (this.totalRecords / this.params.limit <= this.nextPage) {
                    this.moreEntries = false;
                }
            });
        }
    }
}


@NgModule({
    declarations: [CaseStudyPluginComponent],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        DirectivesModule
    ]
})

class CaseStudyPluginModule {
}
